import type { LucideIcon } from 'lucide-react';
import {
  Building2,
  Calendar,
  Clock,
  FileText,
  Tag,
  User,
  Users,
  ClipboardList,
} from 'lucide-react';

const fieldIcon = (Icon: LucideIcon) => <Icon size={18} strokeWidth={2} />;

export const appointmentFieldIcons = {
  hospital: fieldIcon(Building2),
  tag: fieldIcon(Tag),
  person: fieldIcon(User),
  user: fieldIcon(Users),
  appointmentDate: fieldIcon(Calendar),
  startTime: fieldIcon(Clock),
  endTime: fieldIcon(Clock),
  deviceList: fieldIcon(ClipboardList),
  notes: fieldIcon(FileText),
  hospitalName: fieldIcon(Building2),
  hospitalLocation: fieldIcon(Building2),
  prefix: fieldIcon(Tag),
  name: fieldIcon(User),
  phoneNumber: fieldIcon(User),
  email: fieldIcon(User),
};
